module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/bell-o-db66da2afbaff0fb5565bf627e5afe46.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/bell-o.svg
// module id = 7fu8
// module chunks = 24